import { AddIncidentPayload } from '@collector/desktop-feature-incidents-queue-core'

import {
  IncidentQueueCommands,
  IncidentQueuePayloadConfigMetadata,
} from '../../configuration'

export function isHomeParticipant(
  participantId: number,
  metadata: IncidentQueuePayloadConfigMetadata,
): boolean {
  const { homeParticipant } = metadata
  return participantId === homeParticipant.id
}

export function getTeamSide(
  participantId: number,
  metadata: IncidentQueuePayloadConfigMetadata,
): 'home' | 'away' {
  const { eventSettings } = metadata
  const invertedParticipants = eventSettings.invertedParticipants
  if (invertedParticipants)
    return isHomeParticipant(participantId, metadata) ? 'away' : 'home'
  return isHomeParticipant(participantId, metadata) ? 'home' : 'away'
}

export function updatePossession(
  participantId: number,
  metadata: IncidentQueuePayloadConfigMetadata,
): void {
  const { updateEventSettings } = metadata
  updateEventSettings({
    teamSidePossession: getTeamSide(participantId, metadata),
  })
}

export function addIncidentAndUpdatePossession(
  payload: AddIncidentPayload,
  queue: IncidentQueueCommands,
  metadata: IncidentQueuePayloadConfigMetadata,
): void {
  queue.addIncident({ ...payload })

  if (!payload.participant_team_id) return
  updatePossession(payload.participant_team_id, metadata)
}
